import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, ConvenioHistorico } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class ConvenioHistoricoService extends BaseResourceService<ConvenioHistorico> {

  constructor(
    protected injector: Injector
  ) {
    super(`convenio-historicos`, injector);
  }

}
